import React, { useEffect, useState } from 'react';
import '../css/HomeVideo.css';

const HomeVideo = () => {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    fetch("https://adinathbuilder.com/admin/api/home/videos")
      .then(res => res.json())
      .then(data => {
        if (data.status && Array.isArray(data.data)) {
          const filtered = data.data.filter(video => video.video !== null);
          setVideos(filtered.slice(0, 2)); // Show only first 2 videos with valid path
        }
      })
      .catch(err => console.error("Error fetching videos:", err));
  }, []);

  useEffect(() => {
    const videos = document.querySelectorAll('.video');
    const scrollHandler = () => {
      videos.forEach(video => {
        const videoTop = video.getBoundingClientRect().top;
        if (videoTop < window.innerHeight * 0.75) {
          video.classList.add('animate');
        }
      });
    };

    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  return (
    <div className="video-container">
      {videos.map((video, index) => (
        <div key={video.id} className={index === 0 ? "video-left" : "video-right"}>
          <video className="video" width="360" height="215" controls autoPlay muted>
            <source 
              src={`https://adinathbuilder.com/admin/public/${video.video}`} 
              type="video/mp4" 
            />
            Your browser does not support the video tag.
          </video>
        </div>
      ))}
    </div>
  );
};

export default HomeVideo;
